import { render, staticRenderFns } from "./Recruting.vue?vue&type=template&id=71900ce1&"
var script = {}
import style0 from "./Recruting.vue?vue&type=style&index=0&id=71900ce1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports